/**
 * Utility functions for mobile-specific input behavior
 * Prevents iOS Safari from zooming on input focus
 */

const MOBILE_BREAKPOINT = 768;

/**
 * Check if the current viewport is mobile-sized
 * @returns {boolean} true if viewport width is <= mobile breakpoint
 */
const isMobileViewport = () => {
  return window.innerWidth <= MOBILE_BREAKPOINT;
};

/**
 * Apply mobile-specific styles to prevent iOS Safari zoom on input focus
 * @param {HTMLElement} element - The input/textarea element
 */
export const applyMobileInputStyles = (element) => {
  if (isMobileViewport()) {
    // eslint-disable-next-line no-param-reassign
    element.style.fontSize = "16px";
    // eslint-disable-next-line no-param-reassign
    element.style.touchAction = "manipulation";
  }
};

/**
 * Remove mobile-specific styles from input element
 * @param {HTMLElement} element - The input/textarea element
 */
export const removeMobileInputStyles = (element) => {
  if (isMobileViewport()) {
    // eslint-disable-next-line no-param-reassign
    element.style.fontSize = "";
  }
};
